{
  "sectionNav": {
    "label": "Section navigation"
  },
  "header": {
    "logo": {
      "before": "dendo.",
      "dev": "dev"
    },
    "lang": "EN",
    "toggleTheme": "Toggle theme",
    "toggleLang": "Switch to Slovak",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "nav": {
      "home": "Home",
      "work": "Work",
      "about": "About",
      "skills": "Skills",
      "journey": "Journey",
      "blog": "Blog",
      "contact": "Contact"
    }
  },
  "home": {
    "tagline": "Senior React Developer · UX-Minded · Node.js Enthusiast",
    "heading": {
      "before": "Building",
      "highlight": "seamless interfaces",
      "after": "backed by solid systems."
    },
    "perex": "I’m Daniel — a developer bridging invisible architecture and intuitive design through Node.js solutions that transform complex systems into simple and functional environments.",
    "cta": {
      "projects": "View Projects",
      "contact": "Let's talk"
    }
  },
  "work": {
    "heading": "Work",
    "tagline": "Experiences built with purpose.",
    "perex": "A selection of projects I've worked on — from architecture to final interface. Each one taught me something new.",
    "loadMore": "Load {{count}} more"
  },
  "about": {
    "heading": "About",
    "tagline": "Full-stack logic meets human-centered design.",
    "bio1": {
      "before": "Over six years ago, I wrote my first lines of professional code against a database engine. It became my entry point into software engineering. Soon after, I transitioned into React development — the direction I had been aiming for from the start — and began focusing on building modern, usable interfaces.\n\nMy creative nature drew me from frontend to UX/UI design, where I began to focus more on user behavior and the real experience behind the product. This perspective eventually led me into fullstack development with Node.js, where I connect ",
      "highlight": "solid frontend experiences with robust backend architecture",
      "after": ". Today, I work mainly within the React ecosystem, focusing on UX, clean code, and building products that are both scalable and enjoyable to use."
    },
    "portraitLabel": "Daniel - Senior React Developer",
    "chip": {
      "location": "Based in Bratislava",
      "collab": "Open to collab",
      "remote": "Remote-friendly",
      "shipped": "15+ apps shipped"
    }
  },
  "skills": {
    "heading": "Skills",
    "tagline": "Tools I use on a daily basis.",
    "coreTag": "Core",
    "scrollLeft": "Scroll left",
    "scrollRight": "Scroll right",
    "dotLabel": "Scroll to position {{n}}"
  },
  "journey": {
    "heading": "Journey",
    "tagline": "Every step had a reason.",
    "perex": "From database tables through design systems to full-stack architecture — milestones that shaped how I build today.",
    "milestone": {
      "plsql": {
        "title": "PL/SQL Developer",
        "body": "In November 2020, started courses and certifications in web development and React — building the foundation for a career shift. By April 2021, landed the first role as a PL/SQL developer, learning the real weight of data."
      },
      "react": {
        "title": "First commercial React projects",
        "body": "By summer 2021, React studies paid off with the first commercial frontend projects — moving from SQL queries to components, state, and building interfaces users could actually touch."
      },
      "uxui": {
        "title": "UX/UI Designer",
        "body": "In January 2023, stepped into UX/UI design — bridging developer precision and human-centred thinking. Figma became a daily tool, design systems a shared language between engineering and product."
      },
      "frontendLead": {
        "title": "Front-end Stream Leader",
        "body": "In April 2023, took the first front-end stream leader position. Defined architecture standards, led code reviews, mentored developers. The hardest part of engineering is alignment, not code."
      },
      "fullstack": {
        "title": "Full-stack with Node.js",
        "body": "Towards the end of 2025, dove into fullstack architecture and Node.js backends. By early 2026, delivered the first commercial fullstack project — REST APIs, relational databases, and a React frontend from a single hand."
      }
    }
  },
  "blog": {
    "heading": "Blog",
    "tagline": "Some things I keep returning to.",
    "perex": "Practical write-ups on the craft of building React apps and Node services — written between pull requests.",
    "read": "Read",
    "minRead": "min read",
    "loadMore": "Load {{count}} more",
    "backToArticles": "Back to articles",
    "keepReading": "Keep reading",
    "articleNotFound": "Article not found.",
    "articleNav": "Article sections",
    "copy": "Copy",
    "copied": "Copied",
    "copyCode": "Copy code",
    "like": "Like",
    "liked": "Liked",
    "categories": {
      "architecture": "Architecture",
      "code-quality": "Code Quality"
    }
  },
  "project": {
    "backToWork": "Back to projects",
    "myRole": "My role",
    "techStack": "Tech stack",
    "demoHeading": "Interactive preview",
    "projectNotFound": "Project not found.",
    "keepBrowsing": "Keep browsing",
    "projects": {
      "canvas": { "category": "CMS" },
      "northwind": { "category": "Analytics" },
      "pulse": { "category": "Mobile" },
      "orbit": { "category": "Open Source" },
      "synapse": { "category": "Backend" },
      "ledger": { "category": "Finance" },
      "beacon": { "category": "Tooling" },
      "shift": { "category": "SaaS" }
    },
    "demo": {
      "addPlaceholder": "New task…",
      "addBtn": "Add",
      "editBtn": "Edit",
      "saveBtn": "Save",
      "cancelBtn": "Cancel",
      "empty": "No tasks yet — add one above.",
      "taskCount_one": "{{count}} task",
      "taskCount_other": "{{count}} tasks",
      "annotations": {
        "1": {
          "label": "Controlled input",
          "body": "State-driven field blocks submit on empty. Input resets to '' after add without needing a useEffect."
        },
        "2": {
          "label": "Stable keys via crypto.randomUUID()",
          "body": "Each item gets a client-side id on creation so React reconciles rows without index-based instability."
        },
        "3": {
          "label": "Inline edit + auto-focus",
          "body": "Switching a row to edit mode moves focus programmatically to the input — no extra click needed."
        },
        "4": {
          "label": "Animated removal",
          "body": "Row fades and slides out before leaving the DOM — confirms the delete without a blocking dialog."
        }
      }
    }
  },
  "meta": {
    "ogLocale": "en_US",
    "sections": {
      "home": {
        "title": "Senior React Developer & UX Designer | dendo.dev",
        "description": "Daniel Blažíček — building seamless interfaces backed by solid systems. React, Node.js, UX design."
      },
      "work": {
        "title": "Project Portfolio — React & Node.js | dendo.dev",
        "description": "A selection of projects — from architecture to final interface. React, Node.js, full-stack development."
      },
      "about": {
        "title": "About Daniel Blažíček | dendo.dev",
        "description": "Full-stack developer bridging frontend precision with human-centered UX design. Based in Bratislava."
      },
      "skills": {
        "title": "Skills — React, TypeScript, Node.js | dendo.dev",
        "description": "Core tools and technologies I use daily: React, TypeScript, Node.js, Figma, and more."
      },
      "journey": {
        "title": "Career Journey | dendo.dev",
        "description": "From PL/SQL to React and full-stack Node.js — milestones that shaped how I build today."
      },
      "blog": {
        "title": "Blog — React, Node.js & UX | dendo.dev",
        "description": "Practical write-ups on the craft of building React apps and Node services — written between hikes and pull requests."
      },
      "contact": {
        "title": "Contact Daniel Blažíček | dendo.dev",
        "description": "Open to freelance projects, senior roles, and conversations with founders thinking long-term."
      }
    },
    "articleTitleSuffix": " | dendo.dev"
  },
  "error": {
    "articlesFetchFailed": "Couldn't load the articles — please check your connection and try again.",
    "articleFetchFailed": "Couldn't load this article — please check your connection and try again.",
    "relatedFetchFailed": "Couldn't load related articles.",
    "likeFailed": "Couldn't save your like — please try again.",
    "projectsFetchFailed": "Couldn't load the projects — please check your connection and try again.",
    "contactSendFailed": "Couldn't send your message — please check your connection and try again.",
    "dismiss": "Dismiss"
  },
  "footer": {
    "copy": "© 2026 dendo.dev",
    "tagline": "Design, logic, and everything in between."
  },
  "contact": {
    "heading": "Contact",
    "tagline": "Let's start something.",
    "perex": "Open to freelance projects, senior roles, and conversations with founders thinking long-term.",
    "form": {
      "name": "Name",
      "namePlaceholder": "Your name",
      "email": "Email",
      "emailPlaceholder": "your@email.com",
      "message": "Message",
      "messagePlaceholder": "Tell me what you're building.",
      "nameRequired": "Name is required.",
      "emailRequired": "Email is required.",
      "emailInvalid": "Enter a valid email address.",
      "messageRequired": "Message is required.",
      "submit": "Send message",
      "submitting": "Sending…",
      "successTitle": "Message sent.",
      "successBody": "Thank you for reaching out — I'll get back to you as soon as I can."
    },
    "reachDirectly": "Or reach me directly"
  }
}
